// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-title__input--readonly[data-v-bfdb0518]{white-space:pre-wrap;overflow-wrap:break-word}`, "",{"version":3,"sources":["webpack://./src/components/Editor/Properties/PropertyTitle.vue"],"names":[],"mappings":"AACA,kDACC,oBAAA,CACA,wBAAA","sourcesContent":[".property-title__input--readonly{white-space:pre-wrap;overflow-wrap:break-word}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
